import { flow, getOr } from 'lodash/fp';

import { ProductType } from '../../types/product';
import selectRawProduct from '../select-raw-product';

const getOrNull = getOr(null, 'data');
const selectProducts = flow([selectRawProduct, getOrNull]) as (state: any) => Record<string, ProductType>;

export default selectProducts;
